/* libs */
import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { withRouter } from "react-router-dom";

/* components */
import Form from "./Form";
import ChangeHistory from "../../../shared/ChangeHistory";

/* helpers */
import * as modulesActions from "../../../../actions/modulesActions";
import * as themesActions from "../../../../actions/themesActions";

class PagesForm extends Component {
	constructor(props) {
		super(props);
		this.appKey = props.match.params.appKey;
	}

	componentDidMount() {
		const { themesActions } = this.props;
		themesActions.getThemes(this.appKey);
	}

	submitPage = (values, submitHandler) => {
		this.props.onSubmit(values, submitHandler);
	};

	render() {
		const {
			actionType,
			entity,
			filteredModules,
			getFormApi,
			hasFormApi,
			id,
			initialValues,
			isCopy,
			setAppetizePageId,
			setAppetizePause,
			modules: { modules },
			themes: { themes },
		} = this.props;
		const iv = initialValues;
		let formModules = filteredModules ? filteredModules : modules;

		const shouldRender = themes && formModules && formModules.length > 0;

		return shouldRender ? (
			<div>
				{actionType === "update" && !!entity && !!id && <ChangeHistory entity={entity} id={id} />}
				<Form
					initialValues={iv ? iv : {}}
					onSubmit={this.submitPage}
					modules={formModules}
					themes={themes}
					getFormApi={getFormApi}
					hasFormApi={hasFormApi}
					setAppetizePageId={setAppetizePageId}
					setAppetizePause={setAppetizePause}
					buttonLabel={this.props.buttonLabel}
					appKey={this.props.appKey}
					moduleType={this.props.moduleType ? this.props.moduleType : null}
					isCopy={isCopy}
					actionType={actionType}
				/>
			</div>
		) : (
			<h1>Loading...</h1>
		);
	}
}

const mapStateToProps = state => ({
	modules: state.modules,
	themes: state.themes,
});

const mapDispatchToProps = dispatch => ({
	modulesActions: bindActionCreators(modulesActions, dispatch),
	themesActions: bindActionCreators(themesActions, dispatch),
});

PagesForm.propTypes = {
	actionType: PropTypes.string,
	appKey: PropTypes.string,
	buttonLabel: PropTypes.string,
	entity: PropTypes.string,
	getFormApi: PropTypes.func,
	hasFormApi: PropTypes.bool,
	id: PropTypes.string,
	initialValues: PropTypes.object,
	isCopy: PropTypes.bool,
	modules: PropTypes.object,
	modulesActions: PropTypes.object,
	match: PropTypes.object,
	moduleType: PropTypes.string,
	onSubmit: PropTypes.func,
	setAppetizePageId: PropTypes.func,
	setAppetizePause: PropTypes.func,
	themes: PropTypes.object,
	themesActions: PropTypes.object,
	values: PropTypes.object,
};

export default withRouter(
	connect(
		mapStateToProps,
		mapDispatchToProps
	)(PagesForm)
);
